module.exports = __webpack_public_path__ + "static/media/YB5F07_1.29c4d7a4.jpg";